// extracted by mini-css-extract-plugin
export default {"application":"application-list_application__u4IpY","name":"application-list_name__8BAbB","checkbox":"application-list_checkbox__9z93+"};